export default __webpack_public_path__ + "static/media/BARUN.a1cbeb72.jpg";